webpackJsonp([246880939828482],{

/***/ 471:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/bluetooth-printers-distribution/"},"frontmatter":{"title":"Bluetooth Printers Distribution"}}}]}},"pathContext":{"tag":"pos"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-pos-cc341dd9017ca666b431.js